import { files as Files } from "./files"
import { LogPastes } from "./log-pastes"
import { videoEmbeds as VideoEmbeds } from "./video-embeds"
import { formatPastes as FormatPastes } from "./format-pastes"
import { schema as Schema } from "./schema"
import { pasteEmbeds as PasteEmbeds } from "./paste-embeds"

export function Before() {
  return [
    Files(),
    VideoEmbeds(),
    LogPastes(),
    FormatPastes(),
    Schema(),
    PasteEmbeds()
  ]
}

export function After() {
  return []
}

export const plugins = () => [...Before(), ...After()]
